import { useEffect, useState } from 'react'
import ChatHalo from './chat/ChatHalo'
import { Sidebar } from '@/features/sidebar/components'
import { useLocation } from 'react-router-dom'
import { sendPageView } from '@/features/analytics/google'
import TransitionOutlet from './TransitionOutlet'
import rootStore from '@/app/store'
import { observer } from 'mobx-react-lite'
import { ExportMessageDialogProvider } from '@/contexts/ExportMessageDialogContext'
import TermsOfServiceManager from '@/components/TermsOfServiceManager'
import NavigationBlocker from '@/features/chat/components/NavigationBlocker'
import Support from '@/components/Support'
import cx from 'classnames'

const MainLayout = () => {
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false)
  const location = useLocation()

  const { voiceChat } = rootStore

  useEffect(() => {
    sendPageView(location.pathname, 'App')
  }, [location])

  return (
    <ExportMessageDialogProvider>
      <NavigationBlocker />
      <div
        className={cx('main-layout', { 'is-collapsed': isSidebarCollapsed })}
      >
        <Sidebar
          isCollapsed={isSidebarCollapsed}
          setIsCollapsed={setIsSidebarCollapsed}
        />
        <div className="content">
          <div className="content-inner">
            <TransitionOutlet />
            <ChatHalo isVisible={voiceChat.isActive} />
          </div>
        </div>
        {/* Add Terms of Service dialog manager */}
        <TermsOfServiceManager />
        <Support />
      </div>
    </ExportMessageDialogProvider>
  )
}

export default observer(MainLayout)
